// src/pages/GalleryPage.js
import React, { useState, useEffect } from 'react';
import './GalleryPage.css';

// --- Lightbox Imports ---
import Lightbox from 'react-18-image-lightbox'; // <--- Import Lightbox component
import 'react-18-image-lightbox/style.css'; // <--- Import Lightbox CSS (Crucial!)


// Your existing importAll helper function
const importAll = (r) => {
  return r.keys().map(r);
};

function GalleryPage() {
  const [galleryData, setGalleryData] = useState({});
  const [loading, setLoading] = useState(true);

  // --- Lightbox State ---
  const [photoIndex, setPhotoIndex] = useState(0); // Index of the currently viewed photo
  const [isOpen, setIsOpen] = useState(false);     // Whether the lightbox is open
  const [currentCategoryImages, setCurrentCategoryImages] = useState([]); // Images for the *currently active* lightbox

  useEffect(() => {
    const loadCategoryImages = () => {
      const categoriesConfig = {
        classroom: { title: "Classroom", folderName: 'classroom' },
        workshop: { title: "Workshop", folderName: 'workshop' },
        culturalProgram: { title: "3 December Cultural Program", folderName: '3dec_cultural' },
        continuingRehabilitation: { title: "Continuing Rehabilitation Education", folderName: 'continuing_rehabilitation' },
        dignitaryVisit: { title: "Dignitary Visit", folderName: 'dignitary_visit' },
        felicitation: { title: "Felicitation Of Our Sanstha", folderName: 'felicitation' },
        educationalVisits: { title: "Educational Visits And Extra Activity", folderName: 'educational_visits' },
        dayCareCenter: { title: "Day Care Center", folderName: 'day_care_center' },
        helpline: { title: "Helpline", folderName: 'helpline' },
        sports: { title: "Sports", folderName: 'sports' },
        skatingHulahoop: { title: "Skating And Hulahoop", folderName: 'skating_hulahoop' },
        programActivity: { title: "Program Activity", folderName: 'program_activity' },
        picnicMetro: { title: "Picnic & Metro Ride", folderName: 'picnic_metro' },
        onlineCD: { title: "Online Special Edic. CD", folderName: 'online_cd' },
        medicalAssessment: { title: "Medical And Psychological Assessment Camp", folderName: 'medical_assessment' },
      };

      const loadedData = {};

      Object.keys(categoriesConfig).forEach(key => {
        const categoryInfo = categoriesConfig[key];
        const categoryFolderName = categoryInfo.folderName;

        try {
          let images = [];
          switch (categoryFolderName) {
            case 'classroom':
              images = importAll(require.context('../assets/classroom/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'workshop':
              images = importAll(require.context('../assets/workshop/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case '3dec_cultural':
              images = importAll(require.context('../assets/3dec_cultural/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'continuing_rehabilitation':
              images = importAll(require.context('../assets/continuing_rehabilitation/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'dignitary_visit':
              images = importAll(require.context('../assets/dignitary_visit/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'felicitation':
              images = importAll(require.context('../assets/felicitation/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'educational_visits':
              images = importAll(require.context('../assets/educational_visits/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'day_care_center':
              images = importAll(require.context('../assets/day_care_center/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'helpline':
              images = importAll(require.context('../assets/helpline/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'sports':
              images = importAll(require.context('../assets/sports/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'skating_hulahoop':
              images = importAll(require.context('../assets/skating_hulahoop/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'program_activity':
              images = importAll(require.context('../assets/program_activity/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'picnic_metro':
              images = importAll(require.context('../assets/picnic_metro/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'online_cd':
              images = importAll(require.context('../assets/online_cd/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            case 'medical_assessment':
              images = importAll(require.context('../assets/medical_assessment/', false, /\.(png|jpe?g|gif|svg|webp)$/));
              break;
            default:
              console.warn(`No context defined for category: ${categoryFolderName}`);
              break;
          }

          loadedData[key] = {
            title: categoryInfo.title,
            images: images.map(src => ({
              src: src,
              alt: src.split('/').pop().split('.')[0].replace(/[_-\s]/g, ' ')
            }))
          };
        } catch (error) {
          console.error(`Error loading images for category: ${categoryInfo.title} from ../assets/${categoryFolderName}/`, error);
          loadedData[key] = {
            title: categoryInfo.title,
            images: []
          };
        }
      });

      setGalleryData(loadedData);
      setLoading(false);
    };

    loadCategoryImages();
  }, []);

  // --- Lightbox Functions ---
  const openLightbox = (imagesArray, index) => {
    setCurrentCategoryImages(imagesArray); // Set the array of images for the current category
    setPhotoIndex(index);
    setIsOpen(true);
  };

  // Extract just the src URLs for the Lightbox component
  const lightboxImageSources = currentCategoryImages.map(img => img.src);


  if (loading) {
    return <div className="gallery-page-container">Loading gallery...</div>;
  }

  return (
    <div className="gallery-page-container">
      <h1>Our Photo Gallery</h1>

      {Object.keys(galleryData).map(key => (
        <section key={key} className="gallery-category">
          <h2>{galleryData[key].title}</h2>
          <div className="category-images">
            {galleryData[key].images.length > 0 ? (
              galleryData[key].images.map((image, index) => (
                <div
                  key={index}
                  className="gallery-item"
                  onClick={() => openLightbox(galleryData[key].images, index)} // <--- Pass the specific category's images and index
                  style={{ cursor: 'pointer' }} // <--- Add cursor pointer for visual cue
                >
                  <img src={image.src} alt={image.alt} loading="lazy" />
                </div>
              ))
            ) : (
              <p>No images available for this category yet.</p>
            )}
          </div>
        </section>
      ))}

      {/* --- Lightbox Component --- */}
      {isOpen && lightboxImageSources.length > 0 && (
        <Lightbox
          mainSrc={lightboxImageSources[photoIndex]} // The current photo to display
          nextSrc={lightboxImageSources[(photoIndex + 1) % lightboxImageSources.length]} // Next photo (loops back to start)
          prevSrc={lightboxImageSources[(photoIndex + lightboxImageSources.length - 1) % lightboxImageSources.length]} // Previous photo (loops back to end)
          onCloseRequest={() => setIsOpen(false)} // Callback when lightbox is closed
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + lightboxImageSources.length - 1) % lightboxImageSources.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % lightboxImageSources.length)
          }
          // Optional: Add a title/caption below the image
        //   imageTitle={currentCategoryImages[photoIndex]?.title || currentCategoryImages[photoIndex]?.alt || `Photo ${photoIndex + 1}`}
        />
      )}
    </div>
  );
}

export default GalleryPage;